<template>
  <div>
    <div class="alert-content">
      <div class="alert-message" v-html="message" />
    </div>
    <div class="alert-input">
      <input
        name="prompt-value"
        ref="input"
        :type="inputType"
        v-model="internalValue"
        @input="error = false"
        @keyup.enter="validate"
        autofocus
      />
    </div>
    <div class="alert-action">
      <AppBtn @click="action(false)" color="dark-blue-grad">
        Отмена
      </AppBtn>
      <div class="spacer px-3"></div>
      <AppBtn @click="validate" border="bottom" color="yellow-grad">
        Отправить
      </AppBtn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: "text"
    },
    validateFunc: {
      type: Function,
      default: () => false
    }
  },

  data() {
    return {
      internalValue: null,
      error: false
    };
  },

  watch: {
    error(after) {
      this.setModalError(after);
    }
  },

  mounted() {
    this.prepareInput(true);
  },

  methods: {
    setModalError(val) {
      this.$el.parentNode.parentNode.classList.toggle(
        "app-prompt-modal_error",
        val
      );
    },

    prepareInput(clear = false) {
      clear && (this.internalValue = null);
      this.$refs.input.focus();
    },

    validate() {
      this.error = false;
      let res = this.validateFunc(this.internalValue);
      if (res) {
        this.action(true);
      } else {
        this.$nextTick(() => {
          this.error = true;
          this.prepareInput();
        });
      }
    },

    action(confirm) {
      this.$modals.close(confirm);
    }
  }
};
</script>

<style lang="scss">
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.app-prompt-modal {
  .modal-card {
    padding: 16px;
    max-width: 500px;
    transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }

  &.app-prompt-modal_error {
    .modal-card {
      box-shadow: 0 0 0 1px #e72f31;
      animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      perspective: 1000px;
    }

    .alert-input input,
    .alert-input input:focus {
      border-color: #e72f31;
    }
  }

  .alert-content {
    background: none;
    text-align: center;
    font-size: 22px;
    line-height: 28px;
    font-weight: 400;
    color: #fff;
    border-radius: 6px;
    padding: 10px 20px;
    user-select: none;

    b {
      color: #fbc33e;
      font-weight: bold;
    }

    @include breakpoint("xs-only") {
      font-size: 22px;
      line-height: 28px;
    }
  }

  .alert-input {
    margin-top: 15px;

    input {
      width: 100%;
      text-align: center;
      padding: 8px 16px;
      border-radius: 100px;
      color: #fff !important;
      caret-color: #fff !important;
      background: rgba(0, 10, 37, 0.6);
      border: 1px solid rgba(0, 10, 37, 0.6);
      outline: none;
      height: 48px;
      font-size: 16px;
      line-height: 30px;
      transition: border-color 0.2s cubic-bezier(0.4, 0, 0.6, 1);

      &:focus {
        border-color: #1480b2;
      }

      &[type="password"] {
        font-size: 28px;
        line-height: 30px;
        letter-spacing: 4px;
      }

      // @include placeholder() {
      //   font-size: 20px;
      //   letter-spacing: 0px;
      //   vertical-align: middle;
      // }
    }
  }

  .alert-action {
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
</style>
